var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSettings = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M20.202 10.253a1.467 1.467 0 0 0 .833 2.012l.99.352a1.467 1.467 0 0 1 0 2.766l-.99.352a1.467 1.467 0 0 0-.833 2.012l.452.948a1.467 1.467 0 0 1-1.957 1.956l-.949-.45a1.467 1.467 0 0 0-2.012.833l-.352.99a1.467 1.467 0 0 1-2.765 0l-.352-.99a1.467 1.467 0 0 0-2.013-.834l-.948.451a1.467 1.467 0 0 1-1.957-1.956l.451-.95a1.467 1.467 0 0 0-.833-2.012l-.99-.352a1.467 1.467 0 0 1 0-2.766l.99-.352a1.467 1.467 0 0 0 .833-2.01l-.45-.95a1.467 1.467 0 0 1 1.956-1.956l.95.45a1.467 1.467 0 0 0 2.01-.831l.353-.99a1.467 1.467 0 0 1 2.765 0l.352.99a1.467 1.467 0 0 0 2.012.833l.95-.452a1.467 1.467 0 0 1 1.956 1.956z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.001,
  cy: 14,
  r: 3.522,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}))));
export { SvgIconSettings as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-settings.svg";